import React from 'react'
import utils from '../../../../utils'
import { isDelegateFeedbackTab } from '../feedbackBoardType'
import RiskHorizontalDisplay from './RiskHorizontalDisplay'

const ExportPdfV2 = ({
  feedbackDetailData,
  feedbackCommentDataDetailV2,
  selectedOption,
  comment,
  voteDate,
  selectedIndex,
  currentUser,
  feedbackTab,
}) => {
  const { feedbackComments } = feedbackDetailData

  const selectedContentId = Number(selectedIndex)

  const votingDate = voteDate ? new Date(voteDate) : new Date()
  const votingDay = String(votingDate.getDate()).padStart(2, '0')
  const votingMonth = String(votingDate.getMonth() + 1).padStart(2, '0')
  const votingYear = votingDate.getFullYear()

  const checkedUrl = `${window.location.protocol}//${window.location.host}/assets/icons/checkedbox.PNG`
  const uncheckedUrl = `${window.location.protocol}//${window.location.host}/assets/icons/uncheckedbox.PNG`
  const isDelegateTab = isDelegateFeedbackTab(feedbackTab)

  const hasMeaningfulHtml = html =>
    (html || '')
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/gi, ' ')
      .trim() !== ''

  const getLatestCurrentUserFeedback = feedbackComment => {
    const details = (feedbackComment?.feedbackCommentDetails || []).filter(
      detail =>
        detail.feedbackUsername === currentUser?.username &&
        !detail.isDeleted &&
        detail.fileId
    )

    if (!details.length) return null

    return details.sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    )[0]
  }

  const allVotingContents = (feedbackComments || []).map(
    (feedbackComment, idx) => {
      const latestFeedback = getLatestCurrentUserFeedback(feedbackComment)
      const isSelectedContent = feedbackComment.id === selectedContentId

      const userComments = (feedbackComment.feedbackCommentDetails || [])
        .filter(
          detail =>
            detail.feedbackUsername === currentUser?.username &&
            !detail.isDeleted &&
            detail.detailFeedbackComment &&
            detail.detailFeedbackComment.trim() !== ''
        )
        .sort(
          (a, b) =>
            new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
        )
        .map(detail => detail.detailFeedbackComment)
        .join('<br/>')

      return {
        key: feedbackComment.id || idx,
        contentIndex: idx + 1,
        contentHtml: feedbackComment.content || '',
        voteType:
          (isSelectedContent ? selectedOption : null) ||
          latestFeedback?.voteType ||
          '',
        commentHtml: isSelectedContent ? comment || '' : userComments || '',
      }
    }
  )

  return (
    <div
      id="divToPrintPart2"
      style={{
        margin: '20mm',
        paddingRight: '20mm',
        paddingTop: '10mm',
        pageBreakInside: 'auto',
        fontFamily: 'Times New Roman, serif',
        fontSize: '12pt',
        maxWidth: '500px',
        wordWrap: 'break-word',
      }}>
      <style>{`
        .comment-item p { margin: 0; padding: 0; }
        .comment-item p + p { margin-top: 2px; }
      `}</style>

      <div style={{ margin: '0 0 8px 50px', fontWeight: 'bold' }}>
        {isDelegateTab
          ? 'V. BIỂU QUYẾT CỦA NGƯỜI ĐẠI DIỆN'
          : 'V. BIỂU QUYẾT CỦA THÀNH VIÊN HĐQT'}
      </div>

      {allVotingContents.map((contentItem, index) => {
        let uniformHtml = contentItem.contentHtml || ''
        let uniformCommentHtml = contentItem.commentHtml || ''

        if (typeof window !== 'undefined' && window.DOMParser) {
          const parser = new DOMParser()

          // Resize contentHtml
          if (uniformHtml) {
            const doc = parser.parseFromString(uniformHtml, 'text/html')
            doc.querySelectorAll('figure.image').forEach(figure => {
              figure.style.setProperty('width', '460pt', 'important')
            })
            doc.querySelectorAll('img').forEach(img => {
              img.style.setProperty('width', '460pt', 'important')
              img.style.setProperty('height', 'auto', 'important')
              img.style.setProperty('object-fit', 'contain', 'important')
            })
            uniformHtml = doc.body.innerHTML
          }

          // Resize commentHtml
          if (uniformCommentHtml) {
            const doc2 = parser.parseFromString(uniformCommentHtml, 'text/html')
            doc2.querySelectorAll('figure.image').forEach(figure => {
              figure.style.setProperty('width', '460pt', 'important')
            })
            doc2.querySelectorAll('img').forEach(img => {
              img.style.setProperty('width', '460pt', 'important')
              img.style.setProperty('height', 'auto', 'important')
              img.style.setProperty('object-fit', 'contain', 'important')
            })
            uniformCommentHtml = doc2.body.innerHTML
          }
        }

        return (
          <React.Fragment key={`voting-content-${contentItem.key}`}>
            <div
              style={{
                fontWeight: 'bold',
                margin: `${index === 0 ? '0' : '12px'} 0 4px 50px`,
              }}>
              Nội dung {contentItem.contentIndex}:
            </div>

            <div
              className="rich-content"
              style={{
                margin: '0 0 8px 50px',
                textAlign: 'justify',
                lineHeight: '1.7',
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
              }}
              dangerouslySetInnerHTML={{
                __html: uniformHtml,
              }}
            />

            <div style={{ margin: '10px 0 10px 55px' }}>
              <table style={{ border: 'none', width: '100%' }}>
                <tbody>
                  <tr>
                    <td
                      style={{
                        fontSize: '12pt',
                        border: 'none',
                        verticalAlign: 'middle',
                        whiteSpace: 'nowrap',
                      }}>
                      TÁN THÀNH:
                    </td>
                    <td style={{ border: 'none', verticalAlign: 'middle' }}>
                      <img
                        style={{ width: '20px', height: '16px' }}
                        src={
                          contentItem.voteType === 'AGREE'
                            ? checkedUrl
                            : uncheckedUrl
                        }
                        alt="checkbox"
                      />
                    </td>
                    <td style={{ width: '100px', border: 'none' }}></td>
                    <td
                      style={{
                        fontSize: '12pt',
                        border: 'none',
                        verticalAlign: 'middle',
                        whiteSpace: 'nowrap',
                      }}>
                      KHÔNG TÁN THÀNH:
                    </td>
                    <td style={{ border: 'none', verticalAlign: 'middle' }}>
                      <img
                        style={{ width: '20px', height: '16px' }}
                        src={
                          contentItem.voteType === 'DISAGREE'
                            ? checkedUrl
                            : uncheckedUrl
                        }
                        alt="checkbox"
                      />
                    </td>
                    <td style={{ width: '100px', border: 'none' }}></td>
                    {!isDelegateTab && (
                      <>
                        <td
                          style={{
                            fontSize: '12pt',
                            border: 'none',
                            verticalAlign: 'middle',
                            whiteSpace: 'nowrap',
                          }}>
                          KHÔNG CÓ Ý KIẾN:
                        </td>
                        <td
                          style={{
                            border: 'none',
                            verticalAlign: 'middle',
                          }}>
                          <img
                            style={{ width: '20px', height: '16px' }}
                            src={
                              contentItem.voteType === 'OTHER'
                                ? checkedUrl
                                : uncheckedUrl
                            }
                            alt="checkbox"
                          />
                        </td>
                      </>
                    )}
                  </tr>
                </tbody>
              </table>
            </div>

            {hasMeaningfulHtml(contentItem.commentHtml) && (
              <div style={{ margin: '0 0 0 50px', marginTop: '8px' }}>
                <div
                  style={{
                    fontWeight: 'bold',
                    marginBottom: '8px',
                    textAlign: 'left',
                  }}>
                  Ý kiến:
                </div>
                <div
                  className="comment-item rich-content"
                  style={{
                    margin: 0,
                    color: '#000',
                    lineHeight: '1.7',
                    textAlign: 'left',
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word',
                  }}
                  dangerouslySetInnerHTML={{
                    __html: uniformCommentHtml,
                  }}
                />
              </div>
            )}
          </React.Fragment>
        )
      })}

      <RiskHorizontalDisplay
        labels={[
          {
            image: (
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontStyle: 'italic' }}>
                  Ngày {votingDay} tháng {votingMonth} năm {votingYear}
                </div>
                <div style={{ margin: '10px 0', fontStyle: 'italic' }}>
                  Ký và ghi rõ họ tên
                </div>
                <div
                  style={{
                    margin: '90px 0 10px 0',
                    fontWeight: 'bold',
                    fontSize: '14px',
                  }}>
                  {utils.getNameInCapitalize(currentUser?.name_uppercase)}
                </div>
              </div>
            ),
            style: { margin: '0', border: '1px solid white' },
          },
        ]}
        tableStyle={{ margin: '0 0 40px 350px', width: 'calc(100% - 350px)' }}
      />
    </div>
  )
}

export default ExportPdfV2
